import React from 'react';

import './styles.css';

import logoImage from '../../assets/images/logo.png';

export default function Navbar(props) {
    return(
        <div className="navbar-container" id="navbar">
            <div className="navbar-content">
                <div className="logo">
                    <img 
                        src={ logoImage } 
                        alt="Logo" 
                    />
                    <span>laodev.com</span>
                </div>
                <ul>
                    <li><a href="#about">Sobre mim</a></li>
                    <li><a href="#skills">Conhecimentos</a></li>
                    <li><a href="#projects">Projetos</a></li>
                    <li><a href="#contact">Contato</a></li>
                </ul>
            </div>
        </div>
    );
}